import StateTaxIDPage from "components/pages/StateTaxIDPage";

export default function CaptureStateTaxIDs(props) {
    return <StateTaxIDPage/>;
}